export default {
    title: {
        long: 'BackOfficeSystem',
        short: 'System',
    },
    login: {
        title: 'USER LOGIN',
        btn: 'LOGIN',
        username: 'username',
        password: 'password',
    },
    logout: {
        logout: 'logout',
        space: 'space'
    },
    menu: {
        '/': 'home',
        home: 'home',
        mall: 'goodsList',
        user: 'usersList',
        '其他': 'others',
        page1: 'page1',
        page2: 'page2'
    },
    driver: {
        doneBtnText: 'Done',
        closeBtnText: 'Close',
        nextBtnText: 'Next',
        prevBtnText: 'Previous',
        guideBtn: 'Guide',
        hamburgerBtn: 'Hamburger',
        langBtn: 'LanguageChoose'
    },
}